import '../../../../../../Styles/Tabs.scss'
import React, { useState } from 'react'
import { useMutation, useQuery } from '@apollo/client'
import Swal from 'sweetalert2'
import { toastSweetAlert } from '../../../../../Helpers/ToastSweetAlert'
import {
  APPLY_SUSPENSION_USER_APP,
  GET_ONE_USER_APP_BY_ID,
} from '../../../../../../graphql/Catalog/UsersApp/userApp'
import ReportsByUser from '../../../../../Global/UserReports/ReportsByUser'

const ModalReportUserAppInfo = ({
  userAppId,
  refetchOrigin = () => {},
  setCloseModal = () => {},
}) => {
  const [reason, setReason] = useState('')
  const [activeTab, setActiveTab] = useState('info') // Estado para manejar la pestaña activa
  const oneUser = useQuery(GET_ONE_USER_APP_BY_ID, {
    variables: { id: userAppId },
    fetchPolicy: 'no-cache',
  })
  const [suspensionUser] = useMutation(APPLY_SUSPENSION_USER_APP)

  const handleSuspensionUser = async () => {
    if (!reason || reason.trim() === '' || reason.trim().length < 1) {
      return toastSweetAlert({
        mode: 'error',
        message: 'Escribe la razón de suspensión',
      })
    }

    const result = await Swal.fire({
      title: ' ',
      text: '¿Estás seguro que deseas suspender al usuario?',
      icon: 'warning',
      showCancelButton: false,
      showDenyButton: true,
      confirmButtonText: 'Sí, suspender',
      cancelButtonText: 'Cancelar',
      reverseButtons: true,
      buttonsStyling: false,
      customClass: {
        confirmButton: 'btn btn-migrates',
        denyButton: 'btn btn-migrates-white',
      },
    })
    if (!result.isConfirmed) return

    try {
      await suspensionUser({ variables: { id: userAppId, reason } })
      refetchOrigin()
      oneUser.refetch()
      setReason('')
      setCloseModal(true)
      return toastSweetAlert({
        mode: 'ok',
        message: 'Usuario suspendido correctamente',
      })
    } catch (error) {
      console.error(error)
      toastSweetAlert({
        mode: 'error',
        message: 'Ocurrió un error al suspender al usuario',
      })
    }
  }

  return (
    <>
      {/* Sistema de pestañas */}
      <div className="tabs-container">
        <button
          className={`tab-button ${activeTab === 'info' ? 'active' : ''}`}
          onClick={() => setActiveTab('info')}
        >
          Información del Usuario
        </button>
        <button
          className={`tab-button ${activeTab === 'reports' ? 'active' : ''}`}
          onClick={() => setActiveTab('reports')}
        >
          Reportes del Usuario
        </button>
      </div>

      {activeTab === 'info' && (
        <div className="px-3">
          {oneUser.data?.userApp?.suspended && (
            <div className="row">
              <div className="col-12 mb-3">
                <span className="text-danger text-bold">
                  USUARIO SUSPENDIDO
                </span>
              </div>
            </div>
          )}

          <div className="row">
            <div className="col-12 col-sm-6 col-md-6 col-lg-6 mb-3">
              <span className="text-bold">Nombre</span>
              <br />
              <span>{oneUser.data?.userApp?.name || 'N/A'}</span>
            </div>
            <div className="col-12 col-sm-6 col-md-6 col-lg-6 mb-3">
              <span className="text-bold">Apellido Paterno</span>
              <br />
              <span>{oneUser.data?.userApp?.first_name || 'N/A'}</span>
            </div>
            <div className="col-12 col-sm-6 col-md-6 col-lg-6 mb-3">
              <span className="text-bold">Apellido Materno</span>
              <br />
              <span>{oneUser.data?.userApp?.last_name || 'N/A'}</span>
            </div>
            <div className="col-12 col-sm-6 col-md-6 col-lg-6 mb-3">
              <span className="text-bold">Email</span>
              <br />
              <span>{oneUser.data?.userApp?.email || 'N/A'}</span>
            </div>
            <div className="col-12 col-sm-6 col-md-6 col-lg-6 mb-3">
              <span className="text-bold">Telefono</span>
              <br />
              <span>{oneUser.data?.userApp?.phone || 'N/A'}</span>
            </div>
            <div className="col-12 col-sm-6 col-md-6 col-lg-6 mb-3">
              <span className="text-bold">Direccion</span>
              <br />
              <span>{oneUser.data?.userApp?.address || 'N/A'}</span>
            </div>
          </div>
          <hr />
          <div className="row">
            {oneUser.data?.userApp?.suspended === false ? (
              <div className="col-12 mb-3">
                <span className="text-bold">
                  Si deseas suspender este usuario, debes escribir la razon
                </span>
                <br />
                <textarea
                  className="form-control textarea_not_resize rounded-2"
                  rows="5"
                  placeholder="Ingrese la razón de suspensión"
                  maxLength="500"
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                  style={{ width: '100%' }}
                />
              </div>
            ) : (
              <div className="col-12 mb-3">
                <span className="text-bold">Motivo de suspension</span>
                <br />
                <span>{oneUser.data?.userApp?.suspended_reason || 'N/A'}</span>
              </div>
            )}
          </div>
          <div>
            {oneUser.data?.userApp?.suspended === false && (
              <button
                className="btn btn-migrates float-right mt-2 mr-2"
                onClick={() => handleSuspensionUser(userAppId)}
              >
                Suspender usuario
              </button>
            )}
            <button
              className="btn btn-migrates-white float-right mt-2 mr-2"
              onClick={() => {
                setCloseModal(true)
              }}
            >
              Cerrar
            </button>
          </div>
        </div>
      )}

      {activeTab === 'reports' && (
        <div className="row">
          <div className="col-12 mb-3">
            <ReportsByUser userId={userAppId} />
          </div>
        </div>
      )}
    </>
  )
}

export default ModalReportUserAppInfo
